import React, { createContext, useContext, useEffect, useState } from 'react';
import { mlbAPI } from '../services/apiService';

const InjuryContext = createContext({});

export const InjuryProvider = ({ children }) => {
  const [injuryLookup, setInjuryLookup] = useState({});

  useEffect(() => {
    mlbAPI.getInjuryLookup()
      .then(data => setInjuryLookup(data || {}))
      .catch(() => setInjuryLookup({}));
  }, []);

  return (
    <InjuryContext.Provider value={injuryLookup}>
      {children}
    </InjuryContext.Provider>
  );
};

export const useInjury = (mlbId) => {
  const lookup = useContext(InjuryContext);
  if (!mlbId || !lookup[mlbId]) return null;
  return lookup[mlbId];
};
